// Wordle-style share grid generator. Players hit "Share" to copy this string.

import { MAX_DAILY_SCORE, MAX_ROUND_SCORE, MAX_YEAR_SCORE, type RoundResult } from '../../../worker/lib/scoring'
import type { Locale } from '../i18n'
import { fmt } from './format'

const TIER_EMOJI = ['🟥', '🟧', '🟨', '🟩', '🟢']

function tierForScore(score: number, max: number): string {
  const ratio = max > 0 ? score / max : 0
  if (ratio >= 0.95) return TIER_EMOJI[4]!
  if (ratio >= 0.75) return TIER_EMOJI[3]!
  if (ratio >= 0.45) return TIER_EMOJI[2]!
  if (ratio >= 0.20) return TIER_EMOJI[1]!
  return TIER_EMOJI[0]!
}

export function buildShareString(date: string, results: RoundResult[], locale: Locale): string {
  const total = results.reduce((s, r) => s + r.total, 0)
  const grid = results
    .map((r) => tierForScore(r.year_score, MAX_YEAR_SCORE))
    .join(' ')

  return [
    `Egyptle ${date}`,
    `${fmt(total, locale)} / ${fmt(MAX_DAILY_SCORE, locale)}`,
    grid,
    'https://egyptle.app',
  ].join('\n')
}

export { MAX_ROUND_SCORE, MAX_DAILY_SCORE }
